import React from 'react';
import AnnualReportCard from './AnnualReportCard';
import Button from '../../../components/ui/Button';


const AnnualReportsSection = () => {
  const annualReports = [
    {
      id: 1,
      year: "2024",
      coverImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop",
      projectsCompleted: 28,
      beneficiaries: "3,200+",
      volunteerHours: "4,850",
      downloadUrl: "#"
    },
    {
      id: 2,
      year: "2023",
      coverImage: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?w=400&h=300&fit=crop",
      projectsCompleted: 24,
      beneficiaries: "2,800+",
      volunteerHours: "4,200",
      downloadUrl: "#"
    },
    {
      id: 3,
      year: "2022",
      coverImage: "https://images.pixabay.com/photo/2017/07/31/11/21/people-2557396_1280.jpg?w=400&h=300&fit=crop",
      projectsCompleted: 21,
      beneficiaries: "2,400+",
      volunteerHours: "3,650",
      downloadUrl: "#"
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Annual Impact Reports
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Comprehensive documentation of our yearly achievements, featuring detailed project outcomes, financial transparency, and community impact analysis.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {annualReports.map((report) => (
            <AnnualReportCard key={report.id} report={report} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-6">
            Looking for reports from previous years?
          </p>
          <Button variant="outline" iconName="Archive" iconPosition="left">
            View Archive (2018-2021)
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AnnualReportsSection;